module.exports = __webpack_public_path__ + "static/media/Skin_tone_8.8c19319d.svg";